import { render, staticRenderFns } from "./DatatableDetail.vue?vue&type=template&id=eb32480e"
import script from "./DatatableDetail.vue?vue&type=script&lang=js"
export * from "./DatatableDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports